module.exports = "<sx-listado-desplegable \r\n[fuente]=\"grupos\"\r\n[tipo]=\"'CUSTOMER' | i18next\">\r\n</sx-listado-desplegable>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/configuracion/customerTable/configurar.customer.component.html
// module id = ../../../../../src/app/private/configuracion/customerTable/configurar.customer.component.html
// module chunks = main